import React, { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { FloatingActions } from "./FloatingActions";
function ScrollManager() {
  const {
    pathname,
    hash
  } = useLocation();
  useEffect(() => {
    if (hash) {
      const t = window.setTimeout(() => {
        document.getElementById(hash.slice(1))?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }, 60);
      return () => window.clearTimeout(t);
    }
    window.scrollTo({
      top: 0,
      behavior: "auto"
    });
  }, [pathname, hash]);
  return null;
}
export function SiteLayout() {
  return <div className="min-h-screen w-full bg-ink pb-[76px] text-fg md:pb-0" data-id="element-380" data-mp="k50ztge2fhb">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-[80] focus:rounded-full focus:bg-accent focus:px-4 focus:py-2" data-id="element-381" data-mp="3rwpxo8uytpy7">
        Skip to content
      </a>
      <ScrollManager data-id="element-382" data-mp="2z814cw05iox0" />
      <Header data-id="element-383" data-mp="2z6q0yxambj6f" />
      <main id="main" data-id="element-384" data-mp="2z6zp0fc3rg9h">
        <Outlet data-id="element-385" data-mp="1addcd42xqsfv" />
      </main>
      <Footer data-id="element-386" data-mp="1ac2axawypwrx" />
      <FloatingActions data-id="element-387" data-mp="1aclflpxlqoo0" />
    </div>;
}